import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { TranslationNamespace } from '@/i18n';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface StepActionsProps {
	onPrev?: () => void;
	onNext?: () => void;
	nextLabel?: string;
	nextHtmlType?: 'button' | 'submit';
	showPrev?: boolean;
}

export function StepActions({
	onPrev,
	onNext,
	nextLabel,
	nextHtmlType = 'button',
	showPrev = true,
}: StepActionsProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	return (
		<div className={styles.stepActions}>
			{showPrev ? (
				<Button size="large" onClick={onPrev}>
					{t('actions.back')}
				</Button>
			) : (
				<span />
			)}
			<Button
				className={styles.nextButton}
				type="primary"
				size="large"
				htmlType={nextHtmlType}
				onClick={onNext}
			>
				{nextLabel ?? t('actions.continue')}
			</Button>
		</div>
	);
}
